/**
 * How a process row's numbers read, shared by the table and the phone cards so
 * a duration or a movement is spelt the same on both.
 */

// design is drawn by a person, so its row picks a designer where every other
// row picks a press
export const DESIGN_STAGE_KEY = 'design';

export const clock = (seconds) => {
  if (!seconds) return '';
  const h = Math.floor(seconds / 3600);
  const m = Math.round((seconds % 3600) / 60);
  return h ? `${h}h ${m}m` : `${m}m`;
};

export const time = (iso) => (iso ? new Date(iso).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : '');

/** Who moved what, when — one line per movement out of a process. */
export const movementLines = (row) => (row.movements || [])
  .map(m => [
    `${(m.qty_moved || 0).toLocaleString()} → ${m.to_stage_name || 'Completed'}`,
    m.qty_short ? `${m.qty_short.toLocaleString()} short` : null,
    m.direction === 'backward' ? 'sent back' : null,
    m.moved_by_name,
    m.moved_at ? new Date(m.moved_at).toLocaleString() : null,
    m.remarks || null,
  ].filter(Boolean).join(' · '));
